import { useState, useEffect } from "react";
import makeApi, { URLS } from "Utils/apiURL";
import Utils from "Utils/utils";

// SG-2164: same API + response shape as the global member/team filter (see
// Dashboard/reports/UserFilterDropdown.js's getTeamMemberList) — GET /cm/team/filterDetails,
// response.data.groups: [{ group: {id, name}, members: [{memberId, firstName, lastName, email}] }],
// plus response.data.teamMembers: [{memberId, firstName, lastName, email}] (the full member list).
// The backend only populates `groups` when the account actually has team groups; members always live
// under `teamMembers`. So we source "Specific users" from BOTH (deduped) — otherwise an account with
// members but no team groups shows an empty user dropdown. "Specific teams" comes from `groups` only.
// Shared by AudienceScopePopover and ConfigureWidgetPanel so both use the identical source of truth.
const useTeamMembersAndTeams = () => {
  const [members, setMembers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    makeApi({ url: URLS.getTeamData, method: "GET" })
      .then(res => {
        if (cancelled) return;
        const groups = res?.data?.groups || [];
        const teamMembers = res?.data?.teamMembers || [];
        const allMembers = [];
        const allTeams = [];
        const addMember = m => {
          if (m?.memberId && !allMembers.some(existing => existing.memberId === m.memberId)) {
            allMembers.push({ memberId: m.memberId, name: Utils.getFullNameFromUserInfo(m) });
          }
        };
        groups.forEach(item => {
          const { group = {}, members: groupMembers = [] } = item || {};
          if (group?.id) {
            allTeams.push({ id: group.id, name: group.name });
          }
          groupMembers.forEach(addMember);
        });
        // Flat member list — the reliable source when the account has no team groups.
        teamMembers.forEach(addMember);
        setMembers(allMembers);
        setTeams(allTeams);
      })
      .catch(err => console.error("useTeamMembersAndTeams: failed to load team members", err))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, []);

  return { members, teams, loading };
};

export default useTeamMembersAndTeams;
